import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationService } from './notification.service';
import { TranslationService } from './translation.service';
import { EshavaGridApi, EshavaGridColumn, EshavaGridSortOrder } from 'eshava-grid';
import { AbstractSearchResult, ErrorResponse, FilterField, SortField } from '../models';
import { errorMessageConstants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class GridService {

  constructor(
    private _translationService: TranslationService,
    private _notificationService: NotificationService,
  ) { }

  public fillGridFilter(columns: EshavaGridColumn[], filterFields: any, sortFields: any): void {
    columns.forEach(c => {

      if (c.isSearchable && c.search?.searchTerm !== null && c.search?.searchTerm !== undefined && c.search?.searchTerm !== '') {
        const filterField: FilterField = {
          searchTerm: c.search.searchTerm,
          operator: c.search.searchOperator
        };

        if (!!c.search.searchTermAdditional || c.search.searchTermAdditional !== '0') {
          filterField.searchTermAdditional = c.search.searchTermAdditional;
          filterField.operatorAdditional = c.search.searchOperatorAdditional;
        }

        filterFields[c.name] = filterField;
      }

      if (c.isSortable && c.sortOrder !== EshavaGridSortOrder.none) {
        const sortField: SortField = {
          sortOrder: c.sortOrder,
          sortIndex: 0
        };

        sortFields[c.name] = sortField;
      }
    });
  }

  public processSearchApiResult<T>(
    action: Observable<AbstractSearchResult<T>>,
    gridApi: EshavaGridApi,
    firstSearch: boolean,
    errorNotificationTitle: string,
    callback?: (result: AbstractSearchResult<T>) => void): void {

    gridApi.showLoadingOverlay();
    action.subscribe({
      next: response => {
        gridApi.hideOverlay();
        if (response.items.length > 0) {
          gridApi.successCallback(response.items);
          if (firstSearch) {
            gridApi.setSelectedRow(0);
            gridApi.setFooterRows([{ count: response.total }]);
          }

        } else {
          gridApi.successCallback([]);
          if (firstSearch) {
            gridApi.showNoRowsOverlay();
            gridApi.setFooterRows([{ count: response.total }]);
          }
        }

        if (callback) {
          callback(response);
        }
      },
      error: (errorResponse: ErrorResponse) => {
        this._notificationService.showErrorNotification({
          title: errorNotificationTitle,
          message: this._translationService.translate(errorResponse.error?.message || errorMessageConstants.readDataError, 'errors')
        });

        gridApi.hideOverlay();
        gridApi.failCallback();
      }
    });
  }
}
